import { useQuery } from "@tanstack/react-query";
import { DetailsApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";
import { Stage } from "../lusca-search-api/generated-src";
import { getSiblingsQueryKey } from "../helpers/detailsCacheUtils";

export default function useFetchSiblings(
  stage: Stage,
  digitalOrderId: string | undefined
) {
  const DetailsApi = DetailsApiFactory();

  const query = useQuery<string[]>(
    getSiblingsQueryKey(stage, digitalOrderId),
    async () => {
      if (!digitalOrderId) return [];
      const { data } = await DetailsApi.getDetails(stage, digitalOrderId);
      return data.auids || [];
    },
    {
      enabled: !!digitalOrderId,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 5 * 60 * 1000,
    }
  );

  return {
    siblings: query.data || [],
    isLoading: query.isLoading && query.fetchStatus !== "idle",
  };
}
